module.exports = __webpack_public_path__ + "img/logo-white.3e4ef0ba.svg";